export default function valueAxis(
   userTheme,
   axis,
   axisConfig,
   hideLabels,
   onZero,
) {
   const themeColor = userTheme === "Dark" ? "#E6E6E6" : "#171717";

   //Set label width
   let labelWidth = 4; //(padding/boorders?)
   if (axisConfig.labelDisplayLength) {
      labelWidth = labelWidth + axisConfig.labelDisplayLength * 7; //character is approx 7 px. wide
   } else {
      labelWidth = labelWidth + 6 * 7; //5 chars is default for value axes
   }

   let newValueAxis = {
      type: axisConfig.type,
      name: axisConfig.name,
      show: true,
      min: axisConfig.min,
      max: axisConfig.max,
      nameLocation: "middle",
      nameGap: axis === "y" ? labelWidth + 10 : 30,
      nameTextStyle: {
         color: themeColor,
      },
      axisLine: {
         lineStyle: {
            color: themeColor,
         },
         show: true,
         onZero: onZero,
      },
      splitLine: {
         lineStyle: {
            color: ["#C4C4C4", "#B6B8B9"],
         },
      },
      // alignTicks: true,
      axisTick: {
         alignWithLabel: true,
         show: !onZero,
      },
      hideOverlap: true,
      axisLabel: {
         hideOverlap: true,
         width: axis === "y" ? labelWidth : "",
         overflow: axis === "y" ? "truncate" : "none",
         color: themeColor,
         formatter: function (value) {
            if (Math.abs(value) >= 1.0e12) {
               return value / 1.0e12 + "T";
            }
            if (Math.abs(value) >= 1.0e9) {
               return value / 1.0e9 + "B";
            } else if (Math.abs(value) >= 1.0e6) {
               return value / 1.0e6 + "M";
            } else if (Math.abs(value) >= 1.0e3) {
               return value / 1.0e3 + "K";
            }
            return value;
         },
      },
   };

   if (hideLabels) {
      newValueAxis = {
         ...newValueAxis,
         axisLine: {
            show: true,
         },
         axisLabel: {
            show: false,
         },
         nameTextStyle: {
            fontSize: 0,
         },
         nameGap: 0,
      };
   }

   return newValueAxis;
}
